import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

interface NotificationData {
  message: string;
  button?: string;
  duration?: number;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private snackBar: MatSnackBar) {}

  notify({ message, button, duration }: NotificationData) {
    return this.snackBar.open(message, button, { duration });
  }

  dismiss() {
    this.snackBar.dismiss();
  }
}
